import { mapState } from 'vuex';
export default {
  props: {
    nickName: {
      type: String,
      default: ''
    },
    showOperation: {
      type: Boolean,
      default: true
    },
    sessionList: {
      type: Array,
      default: () => []
    },
    sessionSelect: {
      // 用于记录在 session 里面是否选中
      type: Boolean,
      default: false
    },
    createSelect: {
      // 用于创建会话时是否选中
      type: Boolean,
      default: false
    },
    sessionInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    rtc: {
      type: Object,
      default: function () {
        return {};
      }
    },
    singChannel: {
      type: Object,
      default: function () {
        return {};
      }
    },
    speakerId: {
      type: String,
      default: ''
    },
    activeSpeakerInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    index: {
      type: Number,
      default: 0
    },
    deviceVoIPStatus: {
      typee: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      volumeBar: state => state.volumeBar,
      speaker: state => state.speaker,
      allSessionSpeakerInfo: state => state.allSessionSpeakerInfo
    })
  },
  watch: {
    speakerId(val) {
      if (val) {
        var _this$singChannel$aud;
        (_this$singChannel$aud = this.singChannel.audioTrack) === null || _this$singChannel$aud === void 0 ? void 0 : _this$singChannel$aud.setPlaybackDevice(val);
      }
    },
    speaker() {
      this.playAudioBySpeaker();
    },
    singChannel: {
      handler: function (newVal, oldVal) {
        if (newVal.audioTrack) {
          // 设置扬声器
          this.singChannel.audioTrack.setPlaybackDevice(this.speakerId);
          this.$nextTick(() => {
            var _this$volumeBar;
            // 音量住显示
            (_this$volumeBar = this.volumeBar) === null || _this$volumeBar === void 0 ? void 0 : _this$volumeBar.addAudioTrack(this.singChannel.id, newVal.audioTrack._mediaStreamTrack, (volumeLeft, volumeRight) => {
              const dbLeftVal = 20 * Math.log10(volumeLeft * 16);
              const ampLeft = Math.max(dbLeftVal / 60 + 0.8, 0);
              this.level = ampLeft;
            });
            if (oldVal && oldVal.audioTrack) this.rtc.stop(oldVal.audioTrack);
            this.playAudioBySpeaker();
          });
        }
      },
      immediate: true,
      deep: true
    },
    'sessionInfo.sessionSpeaker': {
      handler() {
        this.playAudioBySpeaker();
      }
    },
    'sessionInfo.talentsRtilCodes': {
      handler() {
        this.playAudioBySpeaker();
      }
    },
    'sessionInfo.stationsRtilCodes': {
      handler() {
        this.playAudioBySpeaker();
      }
    },
    'activeSpeakerInfo.sessionSpeaker': {
      handler() {
        this.playAudioBySpeaker();
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      level: 2
    };
  },
  methods: {
    playAudioBySpeaker() {
      let needPlaySource = false;
      const rtilCode = this.singChannel.id;
      const audioTrack = this.singChannel.audioTrack;
      if (!audioTrack) return;
      this.sessionList.forEach(item => {
        if (this.$route.name === 'intercom') {
          var _item$talentsRtilCode, _item$stationsRtilCod;
          if (item.sessionSpeaker && ((_item$talentsRtilCode = item.talentsRtilCodes) !== null && _item$talentsRtilCode !== void 0 && _item$talentsRtilCode.includes(rtilCode) || (_item$stationsRtilCod = item.stationsRtilCodes) !== null && _item$stationsRtilCod !== void 0 && _item$stationsRtilCod.includes(rtilCode))) {
            needPlaySource = true;
          }
        } else {
          var _item$talentsRtilCode2, _item$stationsRtilCod2;
          if (JSON.stringify(this.sessionInfo) != '{}' && ((_item$talentsRtilCode2 = item.talentsRtilCodes) !== null && _item$talentsRtilCode2 !== void 0 && _item$talentsRtilCode2.includes(rtilCode) || (_item$stationsRtilCod2 = item.stationsRtilCodes) !== null && _item$stationsRtilCod2 !== void 0 && _item$stationsRtilCod2.includes(rtilCode))) {
            needPlaySource = true;
          }
        }
      });
      if (needPlaySource) {
        if (this.speaker && !audioTrack._isDestroyed && !audioTrack._isClosed && !audioTrack._played) {
          audioTrack.play(audioTrack, '', {
            type: 'audio'
          });
        }
      } else {
        audioTrack.stop(audioTrack);
      }
    },
    deleteSource() {
      this.$emit('callback');
    }
  }
};